import { twMerge } from "tailwind-merge"
import { BulletIcon } from "../components/BulletIcon"
import { CheckIcon } from "../components/CheckIcon"

export const DescriptionList = (props) => {
  return (
    <div class={twMerge(
      'flex flex-col gap-1',
      props.class ?? ''
    )}>
      <For each={props.descriptions}>{(description) => (
        <div class="flex gap-1">
          <div class="w-2 h-2 text-ink mt-0.5">
            <CheckIcon size={16} fill={'currentColor'} />
          </div>
          <div
            innerHTML={description}
          />
        </div>
      )}</For>
    </div>
  )
}